import { createContext } from 'react';

const AuthContext = createContext({
    isAuthenticated: false,
    setAuth: () => {},
    user: {},
    setUser: () => {},
    isAdmin: false,
    setIsAdmin: () => {},
    ownersSpots: [],
    setOwnersSpots: () => {},
});

export default AuthContext;
